import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/LoginNew'
import Loginlink from '@/components/LoginLink'
import AboutUs from '@/components/AboutUs'
import ContactUs from '@/components/ContactUs'
import Downloads from '@/components/Downloads'
import Policy from '@/components/Policy'
import PmtTerms from '@/components/PmtTerms'
import Terms from '@/components/Terms'
import RegistrationInfo from '@/components/RegisterInfo'
import Dashboard from '@/components/Dashboard'
import Profile from '@/components/EditProfile'
import Payment from '@/components/PaymentReceipt'
import PaymentList from '@/components/PaymentList'
import ViewApp from '@/components/ViewApplication'
//import ViewResults from '@/components/ViewResults'
import ViewResults from '@/components/ApplicationStatus/Result'
import ViewProfile from '@/components/ViewProfile'
import IntimationLetter from '@/components/IntimationLetter'
import UploadDocs from '@/components/UploadDocs'
import Signup from '@/components/Signup'
// import Dtls from '@/components/PaymentsInstaM'
import store from '../store'
// import Dtls2 from '@/components/RegistrationDetails/FeesPaymentBD'
import PaymentConfirm from '@/components/PaymentConfirmInstaM'
import OnlinePayment from '@/components/OnlinePayment/OnlinePayment'
import Registrations from '@/components/OtherRegistrations/Register'
import AgencyPayment from '@/components/OtherRegistrations/FeesPaymentBD'
import EmployerProfile from '@/components/OtherRegistrations/EmployerProfile'
import GuardProfile from '@/components/OtherRegistrations/GuardProfile'
import AgencyProfile from '@/components/OtherRegistrations/AgencyProfile'
import ExcelUpload from '@/components/OtherRegistrations/ExcelUpload'
import ApplyForExemption from '@/components/ApplyForExemption/ApplyForExemption'
import ExemptionList from '@/components/ApplyForExemption/ExemptionList'
import PendingApplication from '@/components/ApplyForExemption/PendingApplication'
import ViewExemptApplication from '@/components/ApplyForExemption/ViewApplication'
import NotificationList from '@/components/ApplyForExemption/NotificationList'

import RegistrationFeesPmt from '@/components/AgencyExemption/RegistrationFeesPmt'
// import TemplateCreator from '@/components/TemplateCreator'agencyprofile
//import Home from '@/components/Home'
import Home from '@/components/Home'
import About from '@/components/Portal/About'
import Organization from '@/components/Portal/Organization'
import Faq from '@/components/Portal/Faq'
import Download from '@/components/Portal/Download'
import Function from '@/components/Portal/Function'
import Power from '@/components/Portal/Power'
import Contact from '@/components/Portal/Contact'
import BoardsList from '@/components/Portal/BoardsList'
import List from '@/components/Portal/List'
import Registration from '@/components/Portal/Registration'
import Bform from '@/components/RegistrationDetails/Bform'
import BFormList from '@/components/RegistrationDetails/BFormList'
import changePassword from '@/components/RegistrationDetails/changePassword'
// import Croppper from '@/components/RegistrationDetails/Croppper'
import AgencyRegistration from '@/components/OtherRegistrations/AgencyRegister'
import SummaryBform from '@/components/SummaryBform'
import BFormPayment from '@/components/RegistrationDetails/BFormPaymentBD'
import ApplicationFees from '@/components/RegistrationDetails/ApplicationFeesPaymentBD'
import RegistrationFees from '@/components/OtherRegistrations/OnBehalfFeesPaymentBD'
import AgencyEmployerMap from '@/components/OtherRegistrations/AgencyEmployerMap'
import AgencyGuardMap from '@/components/OtherRegistrations/AgencyGuardMap'
import MeritList from '@/components/MeritList'
import GuardSurvey from '@/components/GuardSurvey/Survey'
import Thanks from '@/components/GuardSurvey/Thanks'
import ScheduleList from "@/components/ScheduleList"
import EditApplication from '@/components/AgencyExemption/EditApplication'
import EditStgApplication from '@/components/AgencyExemption/EditStgApplication'
import EditStgAgencyApplication from '@/components/AgencyExemption/EditStgAgencyApplication'
import PuneNotice from '@/components/PuneNotice'
import Feesnewpayment from '@/components/RegistrationDetails/Feesnewpayment'



Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    next()
    return
  }
  next('/home')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next()
    return
  }
  next('/')
}


export default new Router({
  routes: [

    {
      path: '/excelupload',
      name: 'ExcelUpload',
      component: ExcelUpload,

    },
    {
      path: '/guardsurvey',
      name: 'GuardSurvey',
      component: GuardSurvey,

    },
    {
      path: '/schedule',
      name: 'ScheduleList',
      component: ScheduleList,

    },
    {
      path: '/thanks',
      name: 'Thanks',
      component: Thanks,

    },
    {
      path: '/',
      name: 'Home',
      component: Home,

    },
    {
      path: '/summarybform/:appid',
      name: 'SummaryBform',
      component: SummaryBform,
      props: true
    },
    {
      path: '/onlinepayment',
      name: 'OnlinePayment',
      component: OnlinePayment,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/agencypayment',
      name: 'AgencyPayment',
      component: AgencyPayment,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/registrationfees',
      namea: 'RegistrationFees',
      component: RegistrationFees,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/loginlink',
      name: 'Loginlink',
      component: Loginlink
    },
    {
      path: '/registrations',
      name: 'Registrations',
      component: Registrations,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/employerprofile',
      name: 'EmployerProfile',
      component: EmployerProfile,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/agencyregistration',
      name: 'AgencyRegistration',
      component: AgencyRegistration,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/agencyemployermap',
      name: 'AgencyEmployerMap',
      component: AgencyEmployerMap,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/agencyguardmap',
      name: 'AgencyGuardMap',
      component: AgencyGuardMap,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/applyforexemption',
      name: 'ApplyForExemption',
      component: ApplyForExemption,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/exemptionlist',
      name: 'ExemptionList',
      component: ExemptionList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/NotificationList',
      name: 'NotificationList',
      component: NotificationList
    },
    {
      path: '/pendingapplication',
      name: 'PendingApplication',
      component: PendingApplication,
      beforeEnter: ifAuthenticated
    },
    {
      path:'/viewexemptapplication',
      name: 'ViewExemptApplication',
      component:ViewExemptApplication,
      beforeEnter:ifAuthenticated,
      props:true
    },
    {
      path: '/registrationfeespmt',
      name: 'RegistrationFeesPmt',
      component: RegistrationFeesPmt,
      props:true
    },
    {
      path: '/guardprofile',
      name: 'GuardProfile',
      component: GuardProfile,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/agencyprofile',
      name: 'AgencyProfile',
      component: AgencyProfile,
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/aboutus',
    //   name: 'AboutUs',
    //   component: AboutUs
    // },
    {
      path: '/privacy',
      name: 'Policy',
      component: Policy
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/paymentterms',
      name: 'PmtTerms',
      component: PmtTerms
    },
    {
      path: '/contactus',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/organization',
      name: 'Organization',
      component: Organization
    },
    {
      path: '/download',
      name: 'Download',
      component: Download
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/function',
      name: 'Function',
      component: Function
    },
    {
      path: '/power',
      name: 'Power',
      component: Power
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/boards',
      name: 'BoardsList',
      component: BoardsList
    },
    {
      path: '/list',
      name: 'List',
      component: List
    },
    {
      path: '/registration',
      name: 'Registration',
      component: Registration
    },
    {
      path: '/bform/:appid',
      name: 'Bform',
      component: Bform,
      props: true
    },
    {
      path: '/registrationinfo',
      name: 'RegistrationInfo',
      component: RegistrationInfo
    },
    // {
    //   path: '/downloads',
    //   name: 'Downloads',
    //   component: Downloads
    // },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/viewprofile',
      name: 'ViewProfile',
      component: ViewProfile,
      beforeEnter: ifAuthenticated,
      props: true
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/applicationfees/:eventid',
      name: 'ApplicationFees',
      component: ApplicationFees,
      beforeEnter: ifAuthenticated,
      props: true
    },
    {
      path: '/Feesnewpayment',
      name: 'Feesnewpayment',
      component: Feesnewpayment,
      beforeEnter: ifAuthenticated,
    },

    {
      path: '/payment',
      name: 'Payment',
      component: Payment,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/paymentlist',
      name: 'PaymentList',
      component: PaymentList,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/viewapp',
      name: 'ViewApp',
      component: ViewApp,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/bformlist',
      name: 'BFormList',
      component: BFormList,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      component: changePassword,
      
    },
    // {
    //   path: '/Croppper',
    //   name: 'Croppper',
    //   component: Croppper,
      
    // },
    {
      path: '/bformpayment',
      name: 'BFormPayment',
      component: BFormPayment,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/results',
      name: 'ViewResults',
      component: ViewResults,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/letter',
      name: 'IntimationLetter',
      component: IntimationLetter,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/upload/:applicationId',
      name: 'UploadDocs',
      component: UploadDocs,
      beforeEnter: ifAuthenticated,
      //props:{applicationId:true}
      props: true
    },
    {
      path: '/signup/:signuptype',
      name: 'Signup',
      component: Signup,
      props: true
    },
    // {
    //   path: '/dtls',
    //   name: 'Dtls',
    //   component: Dtls,
    //   beforeEnter: ifAuthenticated,
    // },
    // {
    //   path: '/dtls2',
    //   name: 'Dtls2',
    //   component: Dtls2,
    //   beforeEnter: ifAuthenticated,
    // },
    {
      path: '/paymentconfirm',
      name: 'PaymentConfirm',
      component: PaymentConfirm,
      props: (route) => ({
        payment_id: route.query.payment_id,
        payment_request_id: route.query.payment_request_id
      })
    },
    {
      path:"/meritlist",
      name:"MeritList",
      component: MeritList
    },
    {
      path: '/EditApplication',
      name: 'EditApplication',
      component: EditApplication,     
      beforeEnter: ifAuthenticated
    },
    {
      path: '/EditStgApplication',
      name: 'EditStgApplication',
      component: EditStgApplication,     
      beforeEnter: ifAuthenticated
    },
    {
      path: '/EditStgAgencyApplication',
      name: 'EditStgAgencyApplication',
      component: EditStgAgencyApplication,     
      beforeEnter: ifAuthenticated
    },
    {
      path:'/punenotice',
      name: 'PuneNotice',
      component: PuneNotice
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js